import styled from 'styled-components';

export const SuccessPageGraphic = styled.img`
  width: 100%;
  max-width: 100%;
`;
